import { render, staticRenderFns } from "./polish.vue?vue&type=template&id=66e86575&scoped=true"
import script from "./polish.vue?vue&type=script&lang=js"
export * from "./polish.vue?vue&type=script&lang=js"
import style0 from "./polish.vue?vue&type=style&index=0&id=66e86575&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e86575",
  null
  
)

export default component.exports